import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditGroupPayload } from '@app-store/slices/group/edit'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.group.edit
const { onEditGroup } = rootActions.group.list

function* editGroupSagaTask({ payload }) {
    try {
        const response = yield axios.patch(`/companies/group/${payload.id}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(onEditGroup(response.result))
            yield payload.sagaCB?.onSuccess()
            notification.success({
                message: 'Group edited successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editGroupSagaTask)
}

export default editGroupSaga
